import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, take} from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);


  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.bypassAuth) {
      return true;
    }
    return this.authService.isAuth().pipe(
      take(1),
      tap(isAuth => {
        if (!isAuth) {
          this.router.navigate(['/login']);
        }
      }),
    );
  }
}
